export default{
    dealHome:{
        Headers:{
            title:'填写并核对订单信息',
            Delivery:'配送信息',
            urchasing:"采购清单",
            merchant:"商家",
            notSelfMention:"当前地区不支持配送，请更换收货地址！",
            shopingMention:"不支持配送商品",
            notSelfpickup:"订单中部分商品不支持自提",
            shopingpickup:"不支持自提商品",
            paymentmethod:"付款方式",
            dialogTitle:"收货地址信息",
            thrxx:"提货人信息",
            title1:'支付订单',
            title2:'账单支付',  
            title3:'订单提交成功！请尽快完成支付。',
            title4:'商品总额',
            title5:'请在',
            title6:'内完成支付, 超时后将取消订单',  
            title7:'商品名称',
            title8:"选择以下支付方式付款",
            title9:"提交成功",
            title10:"支付成功",
            title11:"订单支付成功",
        },
        rules:{
            cityData:"请选择所在地址",
            address:"请输入详细地址信息",
            address1:"请输入4-50字的详细地址信息",
            code:"请输入邮政编码",
            name:"请输入提货人姓名！",
            name1:"请输入2-10字的提货人姓名！",
            tel:"请输入手机号码",
            tel1:"请输入正确的手机号码",
            consigneeName:"请输入2-10字的提货人姓名！",
            password:"请输入正确的密码"
        },
        Notification:{
           
        },
        Message:{
           messagexg:"修改成功！",
           messagetj:"提交成功！",
           errorsh:"请选择收货信息",
           msgpaywayZqzf:"账期额度余额不足",
           msgpaywayZqzf1:"本单应付金额",
           msgpaywayZqzf2:"当前剩余可用额度",
           urls:"请上传支付凭证",
           messageurls:"已复制",
           messageurls1:"复制失败",
        //    msgpaywayZqzf:"账期额度余额不足",
        },
        Alert:{
            AlertTitle:"提示",
            AlertBox:"当前地址信息数已达上限，暂不能添加！",
        },
        Button:{
            Merchant:'商家配送',
            pickup:'买家自提',
            modifyAddress:"修改地址",
            newlyAddress:"新建地址",
            details:"详情",
            details1:"订单详情",
            addressList:"更换收货地址",
            returnorder:"返回进货单",
            orderAdd:"提交订单",
            cancelBtn:"取消",
            saveBtn:"保存",
            saveBtn1:"确定",
            saveBtn2:"全款支付",
            saveBtn3:"分阶段付款",
            saveBtn4:"账期支付",
            saveBtn5:"快捷支付",
            saveBtn6:"对公支付",
            saveBtn7:"线下支付",
            saveBtn8:"确认付款",
            saveBtn9:"查看订单",
            saveBtn10:"继续购物",
            saveBtn11:"返回结算单",
            saveBtn12:"立即付款",
            saveBtn13:"返回",
        },
        form:{
            name:'收货人',
            name1:"收货人姓名",
            tel:"联系方式",
            address:"收货地址",
            shopName:"自提点名称",
            addrDetail:"提货地址",
            consigneeName:"提货人姓名",
            consigneeTel:"手机号码",
            depositFirst:"先付保证金",
            goodstotal:"商品总数",
            goodstnum:"商品总额",
            fareAmount1:'运费金额',
            payableAmount:'应付金额',
            paidAmount:"应付保证金",
            paidAmount1:"已付首笔款",
            balanceAmount:"应付尾款",
            fareAmount:"运费",
            orderAmount:"订单金额",
            depositAmount:"应付保证金",
            cityData:'所在区域 ',
            Dataaddress:"详细地址",
            code:"邮政编码",
            defaultaddress:"默认地址",
            changeAddFlagaddress:'选择收货地址',
            orderNum:'订单号',
            availableCredit:'可用额度',
            password:'支付密码',
            passwordwj:'忘记密码',
            countDowns:"00时00分00秒",
             hour:"时",
            min:"分",
            sec:"秒",
            orderNum1:"订单编号",
            payAmount:"支付金额"
        },
        Placeholder:{

        },
        steps:{
            Operationsteps:"操作步骤",
            Operationsteps1:"1、打开手机银行APP/PC网银，或前往银行柜台",
            Operationsteps2:"2、用您/公司的银行卡向以下账户进行转账",
            Operationsteps3:"收款账户信息",
            Operationsteps4:"复制",
            bankCardNo:"收款账号",
            entpName:"收款户名",
            remarks:"收款银行",
            Operationsteps5:"3、系统自动识别到来账，自动核销订单。",
            Operationsteps6:"4、工作日转账预计2小时内到账，非工作日可能有延迟。",
            Operationsteps7:"上传支付凭证",
            uploadDate:"上传时间",
            xxzffz:"线下支付后，在此处上传支付凭证，上传时需确认凭证信息",
            Operationsteps8:" 1、转账金额与订单金额务必保持一致，不得多转，不得少转，根据订单金额进行转账。",
            Operationsteps9:"2、转账到账时间：建议转账半小时后查看到账情况。工作时间转账预计2小时内到账，非工作时间转账，以付款方银行规则为准。",
            Operationsteps10:"支付说明",
            Operationsteps11:"1、支付方法一：点击页面上“立即支付”按钮，进入支付页面并选择对应支付方式完成支付",
            Operationsteps12:"2、支付方法二：复制下方安全支付链接提交给财务人员，使用浏览器打开链接选择对应支付方式完成支付",
            Operationsteps13:"复制安全支付链接",
            Operationsteps14:"3、系统自动识别到来账，自动核销订单。",
        },
        Validate:{

        },
        Description:{
            placeholdermsg:'如您对运费有异议可留言给商家或提交订单后联系商家协商修改',
            noData:'给卖家留言',
            addressChecked:"设置为默认收货地址",
            msg:"设置后系统将在下单时自动选中该收货地址",
            placeholdermsg1:"请输入收货人姓名",
            placeholdermsg2:"请输入联系方式",
            placeholdermsg3:"完善详细地址",
            placeholdermsg4:"请输入邮政编码",
            submitsuccess:"订单提交成功，请等待商家确认订单！",
            wxts:"温馨提示：收货期间请保持手机畅通，平台不会以订单异常、系统升级为由要求您点击任何网址链接进行退款操作。",
            jsdzfcg:"您的结算单已支付成功，如果需要发票，请及时关注发票状态，进行验票确认。如果不需要发票，请忽略"
            // placeholdermsg5:"请输入收货人姓名",
        },
        Table:{
            headerName:['商品','规格','数量','单价','小计'],
        }
    }
    
}